const actions = {
  // Drawer の表示をトグルする
  TOGGLE_DRAWER({ state, commit }) {
    const flag = !state.showFlag
    commit('SET_DRAWER_FLAG', { flag })
  },
  // Drawer を表示する or しない
  SHOW_DRAWER({ state, commit }, { flag }) {
    commit('SET_DRAWER_FLAG', { flag })
  },
  // Drawer のタイプを決める
  CHANGE_DRAWER_TYPE({ state, commit }, { type }) {
    commit('SET_DRAWER_TYPE', { type })
  },
  CHANGE_DRAWER_TOGGLE_BUTTON_VISIBILITY({ state, commit }, { flag }) {
    commit('SET_DRAWER_TOGGLE_BUTTON_VISIBILITY', { flag })
  },
}

export default actions
